import { DefineDevice } from './define'

export interface hidFilter {
  vendorId: number
  vendorId_new?: number
  productId: number
  productId_new?: number
  usagePage: number
  usage: number
  secondaryProductId?: number // 用于区分vendorId和productId相同的设备
  productName: string
}

export const generateDeviceId = (device: hidFilter, e: HIDDevice): DefineDevice => {
  // secondaryProductId 不存在时，直接用 e 的 vendorId/productId
  if (device.secondaryProductId == undefined) {
    // TODO: // TODO: 兼容旧版 vendorId_new/productId_new 字段；后续待充分测试后，再切换为直接使用 device.vendorId/device.productId
    if (device.productId_new != undefined && device.vendorId_new != undefined) {
      return (device.vendorId * 0x10000 + device.productId) as DefineDevice
    }
    return (e.vendorId * 0x10000 + e.productId) as DefineDevice
  }
  // secondaryProductId 存在时，优先用 device 的 vendorId/productId
  // 格式: secondaryProductId(高32位) + vendorId(中16位) + productId(低16位)
  const deviceID = device.vendorId * 0x10000 + device.productId
  return (device.secondaryProductId * 0x100000000 + deviceID) as DefineDevice
}
// 根据 HIDDevice 获取 DefineDevice
export const getDefineDevice = (e: HIDDevice): DefineDevice => {
  const filters = getFilterGroup().filter(
    (f) =>
      (f.vendorId === e.vendorId || f.vendorId_new === e.vendorId) && (f.productId === e.productId || f.productId_new === e.productId) && (e.productName === f.productName || e.productName.trim() === f.productName || e.productName.includes(f.productName)),
  )
  // 选取 productName 最长的匹配项，以避免前缀匹配问题（如 foo vs foo Pro）
  filters.sort((a, b) => b.productName.length - a.productName.length)
  const filter = filters[0]

  if (!filter) {
    return (e.vendorId * 0x10000 + e.productId) as DefineDevice
  }
  return generateDeviceId(filter, e)
}
// 查找符合条件的 DefineDevice
export const findDefineDeviceByHID = (e: HIDDevice): DefineDevice | undefined => {
  const filters = getFilterGroup().filter(
    (f) =>
      (f.vendorId === e.vendorId || f.vendorId_new === e.vendorId) && (f.productId === e.productId || f.productId_new === e.productId) && (e.productName === f.productName || e.productName.trim() === f.productName || e.productName.includes(f.productName)),
  )
  // 选取 productName 最长的匹配项，以避免前缀匹配问题（如 foo vs foo Pro）
  filters.sort((a, b) => b.productName.length - a.productName.length)
  const deviceHid = filters[0]

  if (deviceHid != undefined) {
    return generateDeviceId(deviceHid, e)
  }
}
// 组合filterGroup 的数据
export const getFilterGroup = (): hidFilter[] => {
  const arr: hidFilter[] = []
  filterGroup.forEach((f) => {
    arr.push(f)
    if (f.productId_new != undefined && f.vendorId_new != undefined) {
      arr.push({
        ...f,
        productId: f.productId_new,
        vendorId: f.vendorId_new,
      })
    }
  })
  return arr
}
const filterGroup: hidFilter[] = [
  {
    //he3se 有线
    vendorId: 0x0c45,
    productId: 0x0500,
    usagePage: 65285,
    usage: 16,
    productName: 'IROK HE3 SE',
  },
  {
    //he3se 无线
    vendorId: 0x0c45,
    productId: 0xc077,
    usagePage: 65286,
    usage: 17,
    productName: 'IROK HE3 SE',
  },
  {
    vendorId: 0x1c4f,
    vendorId_new: 0x1ca2,
    productId: 0xee88,
    productId_new: 0x0402,
    secondaryProductId: 0x10,
    usagePage: 65440,
    usage: 1,
    productName: 'IYX MU68 PRO',
  },
  {
    vendorId: 0x1c4f,
    vendorId_new: 0x1ca2,
    productId: 0xee88,
    productId_new: 0x0401,
    secondaryProductId: 0x20,
    usagePage: 65440,
    usage: 1,
    productName: 'IROK NA87 PRO',
  },
  {
    vendorId: 0x1c4f,
    vendorId_new: 0x1ca2,
    productId: 0xee88,
    productId_new: 0x0406,
    secondaryProductId: 0x30,
    usagePage: 65440,
    usage: 1,
    productName: 'IROK ND63',
  },
  {
    vendorId: 0x1c4f,
    vendorId_new: 0x1ca2,
    productId: 0xee88,
    productId_new: 0x0402,
    secondaryProductId: 0x10,
    usagePage: 65440,
    usage: 1,
    productName: 'MU68 PRO', // PCB 板子
  },
  {
    vendorId: 0x1c4f,
    vendorId_new: 0x1ca2,
    productId: 0xee88,
    productId_new: 0x0401,
    secondaryProductId: 0x20,
    usagePage: 65440,
    usage: 1,
    productName: 'NA87 PRO', // PCB 板子
  },
  {
    vendorId: 0x1c4f,
    vendorId_new: 0x1ca2,
    productId: 0xee88,
    productId_new: 0x0402,
    secondaryProductId: 0x11,
    usagePage: 65440,
    usage: 1,
    productName: 'MU68 PRO CYAN', // 天青轴
  },
  {
    vendorId: 0x1c4f,
    vendorId_new: 0x1ca2,
    productId: 0xee88,
    productId_new: 0x0402,
    secondaryProductId: 0x11,
    usagePage: 65440,
    usage: 1,
    productName: 'IYX MU68 PRO Cyan', // 天青轴
  },
  {
    vendorId: 0x1c4f,
    vendorId_new: 0x1ca2,
    productId: 0xee88,
    productId_new: 0x0406,
    secondaryProductId: 0x31,
    usagePage: 65440,
    usage: 1,
    productName: 'ND63 Cyan', // 天青轴
  },
  {
    vendorId: 0x1c4f,
    vendorId_new: 0x1ca2,
    productId: 0xee88,
    productId_new: 0x0406,
    secondaryProductId: 0x31,
    usagePage: 65440,
    usage: 1,
    productName: 'IROK ND63 Cyan', // 天青轴
  },
  {
    vendorId: 0x1c4f,
    vendorId_new: 0x1ca2,
    productId: 0xee88,
    productId_new: 0x0406,
    secondaryProductId: 0x31,
    usagePage: 65440,
    usage: 1,
    productName: 'IROK ND63 TTC', // 天青轴
  },
  {
    vendorId: 0x1c4f,
    vendorId_new: 0x1ca3,
    productId: 0xee88,
    productId_new: 0x0202,
    secondaryProductId: 0x12,
    usagePage: 65440,
    usage: 1,
    productName: 'IYX MU68 ULTRA', // ULTRA
  },
  {
    vendorId: 0x1ca3,
    productId: 0x0201,
    secondaryProductId: 0x40,
    usagePage: 65440,
    usage: 1,
    productName: 'IYX POLAR75', // polar 75                                                                                                                                                                                                                                    960G
  },
  {
    vendorId: 0x1c4f,
    productId: 0xee88,
    secondaryProductId: 0x40,
    usagePage: 65440,
    usage: 1,
    productName: 'GK6960G', // polar 75 旧版
  },
  {
    vendorId: 0x1c4f,
    vendorId_new: 0x1ca2,
    productId: 0xee88,
    productId_new: 0x0401,
    secondaryProductId: 0x20,
    usagePage: 65440,
    usage: 1,
    productName: 'IROK NA87 PRO Universal', // 全球版
  },
  {
    vendorId: 0x1c4f,
    vendorId_new: 0x1ca2,
    productId: 0xee88,
    productId_new: 0x0402,
    secondaryProductId: 0x10,
    usagePage: 65440,
    usage: 1,
    productName: 'IYX MU68 PRO Universal', // 全球版
  },
  {
    vendorId: 0x1c4f,
    vendorId_new: 0x1ca2,
    productId: 0xee88,
    productId_new: 0x0406,
    secondaryProductId: 0x30,
    usagePage: 65440,
    usage: 1,
    productName: 'IROK ND63 Universal', // 全球版
  },
  {
    vendorId: 0x1c4f,
    vendorId_new: 0x1ca2,
    productId: 0xee88,
    productId_new: 0x0402,
    secondaryProductId: 0x11,
    usagePage: 65440,
    usage: 1,
    productName: 'IYX MU68 PRO Cyan Universal', // 天青轴全球版
  },
  {
    vendorId: 0x1c4f,
    vendorId_new: 0x1ca2,
    productId: 0xee88,
    productId_new: 0x0406,
    secondaryProductId: 0x31,
    usagePage: 65440,
    usage: 1,
    productName: 'IROK ND63 Cyan Universal', // 天青轴全球版
  },
  {
    vendorId: 0x3151,
    productId: 0x5029, //20521
    usagePage: 65535,
    usage: 2,
    secondaryProductId: 0x30,
    productName: 'CAROTMAS Mars68 PRO',
  },
  {
    // CAROTMAS Mars68 PRO 有线
    vendorId: 0x3151,
    productId: 0x5030,
    usagePage: 65535,
    usage: 2,
    productName: 'CAROTMAS Mars68 PRO Wireless',
  },
  {
    // CAROTMAS Mars68 PRO 无线
    vendorId: 0x3151,
    vendorId_new: 0x3151,
    productId: 0x502b,
    productId_new: 0x5038,
    usagePage: 65535,
    usage: 2,
    productName: 'Mars68 2.4G',
  },
  {
    vendorId: 0x3151,
    productId: 0x5029, //20521
    usagePage: 65535,
    usage: 2,
    secondaryProductId: 0x10,
    productName: 'CAROTMAS Mars68 SE',
  },
  {
    vendorId: 0x3151,
    productId: 0x5029, //20521
    usagePage: 65535,
    usage: 2,
    secondaryProductId: 0x20,
    productName: 'CAROTMAS Mars68',
  },
  {
    // CAROTMAS Mars68 有线
    vendorId: 0x3151,
    productId: 0x5030, //20521
    usagePage: 65535,
    usage: 2,
    secondaryProductId: 0x40,
    productName: 'CAROTMAS Mars68 Wireless',
  },
  {
    // CAROTMAS Mars68 无线
    vendorId: 0x3151,
    productId: 0x5026, //20518
    usagePage: 65535,
    usage: 2,
    productName: 'Mars68 2.4G',
  },
  {
    vendorId: 0x3151,
    productId: 0x502e,
    usagePage: 65535,
    usage: 2,
    productName: 'MonsGeek Keyboard',
  },
  {
    vendorId: 0x3151,
    productId: 0x502d,
    usagePage: 65535,
    usage: 2,
    productName: 'MonsGeek Keyboard',
  },
  {
    vendorId: 0x3151,
    productId: 0x4011,
    usagePage: 65535,
    usage: 2,
    productName: 'MonsGeek 2.4G Wireless Keyboard',
  },
  //MG68
  {
    vendorId: 0x3151,
    productId: 0x502d, // 20525
    usagePage: 65535,
    usage: 2,
    secondaryProductId: 0x30,
    productName: 'IROK MG68 PRO',
  },
  {
    vendorId: 0x3151,
    productId: 0x502d,
    usagePage: 65535,
    usage: 2,
    secondaryProductId: 0x20,
    productName: 'IROK MG68 SE',
  },
  {
    vendorId: 0x3151,
    productId: 0x502f,
    usagePage: 65535,
    usage: 2,
    productName: 'IROK MG68 MAX',
  },
  {
    vendorId: 0x3151,
    vendorId_new: 0x3151,
    productId: 0x502b,
    productId_new: 0x5038,
    usagePage: 65535,
    usage: 2,
    secondaryProductId: 0x10,
    productName: '2.4G Wireless Keyboard', // MG68 MAX 2.4G
  },
  {
    vendorId: 0x3151,
    productId: 0x502d,
    usagePage: 65535,
    usage: 2,
    secondaryProductId: 0x40,
    productName: 'IROK MG68 LITE',
  },
  {
    vendorId: 0x3151,
    productId: 0x502d,
    usagePage: 65535,
    usage: 2,
    secondaryProductId: 0x10,
    productName: 'IROK MG68',
  },
  {
    vendorId: 0x1ca5,
    vendorId_new: 0x1ca5,
    productId: 0x0807,
    productId_new: 0x0809,
    usagePage: 65440,
    usage: 1,
    secondaryProductId: 0x10,
    productName: 'IROK MG75',
  },
  {
    vendorId: 0x1ca5,
    productId: 0x0807,
    usagePage: 65440,
    usage: 1,
    secondaryProductId: 0x20,
    productName: 'IROK MG75 PRO',
  },
  {
    vendorId: 0x1ca5,
    productId: 0x0806,
    usagePage: 65440,
    usage: 1,
    secondaryProductId: 0x10,
    productName: 'CAROTMAS Mer68',
  },
  {
    vendorId: 0x1ca5,
    productId: 0x0806,
    usagePage: 65440,
    usage: 1,
    secondaryProductId: 0x11,
    productName: 'CAROTMAS Mer68 PRO',
  },
  {
    vendorId: 0x3151,
    productId: 0x5029,
    usagePage: 65440,
    usage: 1,
    secondaryProductId: 0x40,
    productName: 'CAROTMAS Mer68 SE',
  },
  {
    vendorId: 0x3151,
    productId: 0x5029,
    usagePage: 65440,
    usage: 1,
    secondaryProductId: 0x41,
    productName: 'CAROTMAS Mer68 Lite',
  },
  {
    vendorId: 0x3554,
    productId: 0xfb36,
    usagePage: 65282,
    usage: 2,
    productName: 'HE6 Ultra', // he6Ultra
    // productName: '2.4G Dual Mode Mouse',
  },
  {
    vendorId: 0x3554,
    productId: 0xfb35,
    usagePage: 65282,
    usage: 2,
    productName: 'HE6 Ultra', // he6Ultra 无线
  },
  {
    vendorId: 0x1ca6,
    productId: 0x0529,
    usagePage: 65456,
    usage: 1,
    productName: 'IROK MG75 MAX',
  },
  {
    vendorId: 0x1ca6,
    productId: 0x0529,
    usagePage: 65456,
    usage: 1,
    productName: 'keyboard', // IROK MG75 MAX boot 模式
  },
  {
    vendorId: 0x1ca6,
    productId: 0x052a,
    usagePage: 65456,
    usage: 1,
    productName: 'IROK MG68 Plus',
  },
  {
    vendorId: 0x1ca6,
    productId: 0x052a,
    usagePage: 65456,
    usage: 1,
    productName: 'keyboard', // IROK MG68 Plus boot 模式
  },
  {
    vendorId: 0x3151,
    productId: 0x5029,
    usagePage: 65456,
    usage: 2,
    secondaryProductId: 0x50,
    productName: 'IROK MG68 ACE',
  },
  {
    vendorId: 0x3151,
    productId: 0x5029,
    usagePage: 65456,
    usage: 2,
    secondaryProductId: 0x51,
    productName: 'MG68', // IROK MG68 ACE 升级固件后名称变更为 MG68  驱动中识别为 MG68 Plus
  },
  {
    vendorId: 0x3151,
    productId: 0x5030,
    usagePage: 65456,
    usage: 2,
    secondaryProductId: 0x51,
    productName: 'IROK MG68 ACEW',
  },
  {
    vendorId: 0x3151,
    productId: 0x5038,
    usagePage: 65535,
    usage: 2,
    secondaryProductId: 0x52,
    productName: '2.4G Wireless Keyboard', // IROK MG68 ACEW 无线
  },
  {
    vendorId: 0x1ca6,
    productId: 0x052b,
    usagePage: 65456,
    usage: 1,
    productName: 'CAROTMAS Mars75',
  },
  {
    vendorId: 0x1ca6,
    productId: 0x052b,
    usagePage: 65456,
    usage: 1,
    secondaryProductId: 0x10,
    productName: 'CAROTMAS Mars75 PRO',
  },
  {
    vendorId: 0x1ca6,
    productId: 0x052b,
    usagePage: 65456,
    usage: 1,
    productName: 'keyboard', // CAROTMAS Mars75/CAROTMAS Mars75PRO  boot 模式
  },
  {
    vendorId: 0x1ca6,
    productId: 0x052c,
    usagePage: 65456,
    usage: 1,
    productName: 'IROK ND68',
  },
  {
    vendorId: 0x1ca6,
    productId: 0x052c,
    usagePage: 65456,
    usage: 1,
    productName: 'keyboard', // IROK ND68  boot 模式
  },
  {
    vendorId: 0x3151,
    productId: 0x5029,
    usagePage: 65535,
    usage: 2,
    productName: 'IROK ND-68', // 容圆方案 0.005
  },
  {
    vendorId: 0x3151,
    productId: 0x502d,
    usagePage: 65535,
    usage: 2,
    secondaryProductId: 0x60,
    productName: 'IROK ND_63', // 容圆方案 0.005
  },
  {
    vendorId: 0x1ca6,
    productId: 0x0531,
    usagePage: 65456,
    usage: 1,
    productName: 'IROK ND-63', // 星闪方案 0.001  nd63 ultra
  },
  {
    vendorId: 0x1ca6,
    productId: 0x0531,
    usagePage: 65456,
    usage: 1,
    productName: 'keyboard', // IROK ND-63 boot 模式
  },
  {
    vendorId: 0x1ca6,
    productId: 0x052d,
    usagePage: 65456,
    usage: 1,
    productName: 'CAROTMAS_MER68', // 星闪方案 0.001
  },
  {
    vendorId: 0x1ca6,
    productId: 0x052d,
    usagePage: 65456,
    usage: 1,
    productName: 'keyboard', // CAROTMAS_MER68 boot 模式
  },
  {
    vendorId: 0x19bf,
    productId: 0x1020,
    usagePage: 65440,
    usage: 1,
    productName: 'IROK Fe87 V2', // FE87V2 三模 '机械'
  },
  {
    vendorId: 0x19bf,
    productId: 0x1020,
    usagePage: 65440,
    usage: 1,
    productName: 'IROK FeV2 C38', // FE87V2 三模 '机械' 第二批货改名
  },
  {
    vendorId: 0x19bf,
    productId: 0x1020,
    usagePage: 65440,
    usage: 1,
    productName: 'IROK FeV2 C18', // FE87V2 单模 机械键盘
  },
  {
    vendorId: 0x19bf,
    productId: 0x1030,
    usagePage: 65440,
    usage: 1,
    productName: 'IROK Fe87 V2 IMC', // FE87V2  旧IMC模式
  },
  {
    vendorId: 0x19bf,
    productId: 0x1030,
    usagePage: 65440,
    usage: 1,
    productName: 'IROK FeV2I C38OH', // FE87V2  旧IMC模式 第二批货改名
  },
  {
    vendorId: 0x19bf,
    productId: 0x1030,
    usagePage: 65440,
    usage: 1,
    productName: 'IROK FeV2I C38NH', // FE87V2 新IMC模式
  },
  {
    vendorId: 0x19bf,
    productId: 0x1010,
    usagePage: 65440,
    usage: 1,
    productName: 'CAROTMAS Mer68SE', // 自研磁轴驱动
  },
  {
    vendorId: 0x1ca6,
    productId: 0x0528,
    usagePage: 65456,
    usage: 1,
    productName: 'IROK RA68',
  },
  {
    vendorId: 0x1a86,
    productId: 0x8300,
    usagePage: 65408,
    usage: 1,
    productName: 'IROK FeV2 C3824G', // FE87V2 三模 纯机械 2.4G模式
  },
  {
    vendorId: 0x1a86,
    productId: 0x8300,
    usagePage: 65408,
    usage: 1,
    secondaryProductId: 0x10,
    productName: 'IROK FeV2I 3824G', // FE87V2 IMC 2.4G模式
  },
  {
    vendorId: 0x1a86,
    productId: 0x8300,
    usagePage: 65408,
    usage: 1,
    productName: 'Fe87 V2', // FE87V2 旧版 2.4G接收器（机械轴和IMC都是这个）
  },
  {
    vendorId: 0x2f81,
    productId: 0x3004,
    usagePage: 65281,
    usage: 1,
    productName: 'IROK MG63', // MG63 火柴人方案
  },
  {
    vendorId: 0x2f81,
    productId: 0x3005,
    usagePage: 65281,
    usage: 1,
    productName: 'IROK RA68 CORE2', // ra68 火柴人方案
  },
  {
    vendorId: 0x2f81,
    productId: 0x3007,
    usagePage: 65281,
    usage: 1,
    productName: 'IROK MG75V2 C12', // MG75V2 火柴人方案
  },
  {
    vendorId: 0x28e9,
    productId: 0x320e,
    usagePage: 65415,
    usage: 32,
    productName: 'IROK FeV2 C18 WL', // fe87 V2 暮烟轴- 智慧无限方案
  },
]

// 如果有设备同时存在有线和无线状态, 只取用有线状态
export const filterGroupConflict: hidFilter[][] = [
  // HE3SE
  [filterGroup[0], filterGroup[1]],
  [
    {
      vendorId: 0x3151,
      productId: 0x5030,
      usagePage: 65535,
      usage: 2,
      productName: 'CAROTMAS Mars68 PRO Wireless',
    },
    {
      vendorId: 0x3151,
      vendorId_new: 0x3151,
      productId: 0x502b,
      productId_new: 0x5038,
      usagePage: 65535,
      usage: 2,
      productName: 'Mars68 2.4G', // CAROTMAS Mars68 PRO
    },
  ],
  [
    {
      vendorId: 0x3151,
      productId: 0x5030, //20521
      usagePage: 65535,
      usage: 2,
      secondaryProductId: 0x40,
      productName: 'CAROTMAS Mars68 Wireless',
    },
    {
      vendorId: 0x3151,
      productId: 0x5026, //20518
      usagePage: 65535,
      usage: 2,
      productName: 'Mars68 2.4G', // CAROTMAS Mars68
    },
  ],
  [
    {
      vendorId: 0x3151,
      productId: 0x502f,
      usagePage: 65535,
      usage: 2,
      productName: 'IROK MG68 MAX',
    },
    {
      vendorId: 0x3151,
      productId: 0x502b,
      usagePage: 65535,
      usage: 2,
      secondaryProductId: 0x10,
      productName: '2.4G Wireless Keyboard', // MG68 MAX 2.4G
    },
  ],
  [
    {
      vendorId: 0x3151,
      productId: 0x5030,
      usagePage: 65456,
      usage: 2,
      secondaryProductId: 0x51,
      productName: 'IROK MG68 ACEW',
    },
    {
      vendorId: 0x3151,
      productId: 0x5038,
      usagePage: 65535,
      usage: 2,
      secondaryProductId: 0x52,
      productName: '2.4G Wireless Keyboard', // IROK MG68 ACEW 无线
    },
  ],
  [
    {
      vendorId: 0x3554,
      productId: 0xfb36,
      usagePage: 65282,
      usage: 2,
      productName: 'HE6 Ultra', // he6Ultra
    },
    {
      vendorId: 0x3554,
      productId: 0xfb35,
      usagePage: 65282,
      usage: 2,
      productName: 'HE6 Ultra', // he6Ultra 无线
    },
  ],
  [
    {
      vendorId: 0x19bf,
      productId: 0x1020,
      usagePage: 65440,
      usage: 1,
      productName: 'IROK FeV2 C38', // FE87V2 三模 '机械' 第二批货改名
    },
    {
      vendorId: 0x1a86,
      productId: 0x8300,
      usagePage: 65408,
      usage: 1,
      productName: 'IROK FeV2 C3824G', // FE87V2 三模 纯机械 2.4G模式
    },
  ],
  [
    {
      vendorId: 0x19bf,
      productId: 0x1030,
      usagePage: 65440,
      usage: 1,
      productName: 'IROK FeV2I C38OH', // FE87V2  旧IMC模式 第二批货改名
    },
    {
      vendorId: 0x1a86,
      productId: 0x8300,
      usagePage: 65408,
      usage: 1,
      secondaryProductId: 0x10,
      productName: 'IROK FeV2I 3824G', // FE87V2 IMC 2.4G模式
    },
  ],
  [
    {
      vendorId: 0x19bf,
      productId: 0x1030,
      usagePage: 65440,
      usage: 1,
      productName: 'IROK FeV2I C38NH', // FE87V2 新IMC模式
    },
    {
      vendorId: 0x1a86,
      productId: 0x8300,
      usagePage: 65408,
      usage: 1,
      secondaryProductId: 0x10,
      productName: 'IROK FeV2I 3824G', // FE87V2 IMC 2.4G模式
    },
  ],
]
